/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountHistoryDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountHistoryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantBrokerAccountUpdatedHistoryService {

    /**
     * @param participantBrokerAccountId 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountHistoryDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBrokerAccountUpdatedHistoryBrokerAccountUpdatedHistoryByParticipantBrokerAccountId(
participantBrokerAccountId: string,
): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broker-account-updated-history/broker-account-updated-history-by-participant-broker-account-id/{ParticipantBrokerAccountId}',
            path: {
                'ParticipantBrokerAccountId': participantBrokerAccountId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
